import { ResponseHeaderId } from "../../response/models/events";
import { FetchDeviceListRequestBody, InstallGadgetOnDeviceBody } from "./body";

export type GarudaRequestBody = FetchDeviceListRequestBody | InstallGadgetOnDeviceBody;

export type RequestHeaderId = "FetchDeviceListRequest" | "InstallGadgetOnDevice";

type HeaderId = RequestHeaderId | ResponseHeaderId;

export enum Result {
  SUCCESS = 200,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
}

export class Header {
  private id: HeaderId;
  private version: string;

  constructor(requestType: HeaderId) {
    this.id = requestType;
    this.version = "2.0";
  }
}

export abstract class GarudaRequest {
  private header: Header;
  protected body: GarudaRequestBody;

  constructor(
    requestType: RequestHeaderId,
    body: GarudaRequestBody,
  ) {
    this.header = new Header(requestType);
    this.body = body;
  }
}

export class FetchDeviceListRequest extends GarudaRequest {
  constructor(uid:string) {
    super(
      "FetchDeviceListRequest",
      new FetchDeviceListRequestBody(uid)
    );
  }
}

export class InstallGadgetOnDeviceRequest extends GarudaRequest {
  constructor(uid: string, gadgetURL: string, devices: string[], sizeInBytes: number, gadgetId: number) {
    super(
      "InstallGadgetOnDevice",
      new InstallGadgetOnDeviceBody(uid, gadgetURL, devices, sizeInBytes, gadgetId)
    );
  }
}